/* eslint camelcase: 0 */
import { getBackVersion } from '../../config';
import { CRMIntegrationsSnapshot } from '../../models/CRM/CRMIntegrations';
import api from '../api';

const getIntegrations = (): Promise<CRMIntegrationsSnapshot> =>
    api.request<CRMIntegrationsSnapshot>({
        method: 'GET',
        url: `${getBackVersion()}/agent/ai/integrations`,
    });

const updateListingsSyncUrl = (url: string): Promise<CRMIntegrationsSnapshot> =>
    api.request<CRMIntegrationsSnapshot>({
        method: 'POST',
        url: `${getBackVersion()}/agent/ai/integrations/listings_sync_url`,
        params: { url },
    });

const whatsappIntegration = (
    code: string,
    phoneId: string,
    wabaId: string
): Promise<CRMIntegrationsSnapshot> =>
    api.request<CRMIntegrationsSnapshot>({
        method: 'POST',
        url: `${getBackVersion()}/agent/ai/integrations/whatsapp`,
        params: { exchangeable_code: code, waba_id: wabaId, phone_id: phoneId },
    });

export default { getIntegrations, updateListingsSyncUrl, whatsappIntegration };
